import { render, staticRenderFns } from "./ProductsStore.vue?vue&type=template&id=2af5b670&"
import script from "./ProductsStore.vue?vue&type=script&lang=js&"
export * from "./ProductsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports